import { Component, OnInit, Input, SimpleChanges, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-view-professor-curriculum',
  templateUrl: './view-professor-curriculum.component.html',
  styleUrls: ['./view-professor-curriculum.component.scss']
})
export class VievProfessorCurriculumComponent implements OnInit {

  @Input() curriculum: any;
  @Input() professor: any;
  isModal: boolean;

  constructor(
    @Optional() public dialogRef: MatDialogRef<VievProfessorCurriculumComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.isModal = true;
      this.curriculum = data.curriculum;
      this.professor = data.professor;
    } else {
      this.isModal = false;
    }
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['curriculum']) {
      this.curriculum = changes['curriculum'].currentValue;
    }
    if (changes['professor']) {
      this.professor = changes['professor'].currentValue;
    }
  }

  async ngOnInit() {
  }
}
